import { DIVISION_KINDS, ROLES_WITHOUT_GLOBAL_SEARCH, SearchType, USER_ROLES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { useSearch } from './contexts/SearchContext';
import { useUserData } from '../hooks/useUserData';
import useUserInfo from '~/hooks/useUserInfo';

export const SearchTypeSwitch = () => {
    const { t } = useTranslation();
    const { searchType, setSearchType } = useSearch();

    const user = useUserInfo();
    const { data: userData } = useUserData(user?.id);

    if (
        !user ||
        ROLES_WITHOUT_GLOBAL_SEARCH.includes(user.role) ||
        userData?.divisionKind !== DIVISION_KINDS.INTERNAL
    ) {
        return null;
    }

    let ownLeadsText = t('LEADS.SEARCH.USER');
    switch (user?.role) {
        case USER_ROLES.team_leader:
            ownLeadsText = t('LEADS.SEARCH.TEAM_LEADER');
            break;
        case USER_ROLES.division_leader:
            ownLeadsText = t('LEADS.SEARCH.DIVISION_LEADER');
            break;
        default:
            ownLeadsText = t('LEADS.SEARCH.USER');
            break;
    }

    return (
        <div className="text-xs text-blue-dark flex gap-2 items-center">
            <span>{t('LEADS.SEARCH.TYPE')}</span>
            <div className="bg-gray-100 p-0.5 rounded-md inline-flex">
                <button
                    onClick={() => setSearchType(SearchType.GLOBAL)}
                    className={`
          px-2 py-1 text-xs font-medium rounded transition-all duration-200
          ${searchType === SearchType.GLOBAL ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}
        `}
                >
                    {t('LEADS.SEARCH.GLOBAL')}
                </button>
                <button
                    onClick={() => setSearchType(SearchType.USER)}
                    className={`
          px-2 py-1 text-xs font-medium rounded transition-all duration-200
          ${searchType === SearchType.USER ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}
        `}
                >
                    {ownLeadsText}
                </button>
            </div>
        </div>
    );
};
